export default __webpack_public_path__ + "static/media/my resume.4dd65d56.pdf";